import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { createStyleComponent } from "@hzero-front-ui/core";
var getIconCss = function getIconCss() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    a[disabled] {\n      color: rgba(0, 0, 0, 0.25) !important;\n    }\n  "])));
};
export default createStyleComponent("comp/icon", getIconCss);